import { render } from "./CustomerAccountData.vue?vue&type=template&id=7ceb270a"
import script from "./CustomerAccountData.vue?vue&type=script&lang=ts"
export * from "./CustomerAccountData.vue?vue&type=script&lang=ts"
script.render = render

export default script